// extracted by mini-css-extract-plugin
export default {"About":"About_About__-V3sE"};